import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-view',
  templateUrl: './header-view.component.html',
  styleUrls: ['./header-view.component.css']
})
export class HeaderViewComponent implements OnInit {

  @Input() titulo: string;
  @Input() subTitulo: string;
  @Input() detalhado: boolean = false;
  @Input() mini: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
